module.exports = __webpack_public_path__ + "img/SL-M-100-180.9c111a70.svg";